import AdminCommon from './modules/AdminCommon';


jQuery(document).ready(($) => {
	window.$ = $;
	new AdminCommon(window.dp_admin_always_config);
});
